<template>
  <div>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";
import UtilityHelper from "@/plugins/UtilityHelper";

export default {
  name: "optima-toolbar",

  data: () => ({
    webService: null,
    utilityHelper: null,

  }),

  created() {
    this.webService = new WebService(this);
    this.utilityHelper = new UtilityHelper(this);
  },

  methods: {
  },

  watch: {
  }
};
</script>

<style scoped>
.toolbar {
  margin: 20px 0;
  /*float: left; Remove this*/
  display: inline-block; /*Add this*/
}
</style>
